import { Component, OnInit } from '@angular/core';
import { IconDefinition } from '@fortawesome/fontawesome-common-types';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { WellKnownIconsEnum } from 'src/app/helper/iconHelper';
import { LanguageType } from 'src/app/samwebDescription/samweb/settings/language-types';
import { ThemeType } from 'src/app/samwebDescription/samweb/settings/theme-type';
import { FeatureEnum } from 'src/app/samwebDescription/samwin/FeatureEnum';
import { EnabledFeaturesState } from 'src/app/store/session/enabled-features/enabled-features.state';
import {
   SetTemporaryTheme,
   SettingsChangeApplicationLanguage,
   SettingsChangeTheme,
   SettingsChangeWarnBeforeClosingTab,
} from 'src/app/store/settings/settings.actions';
import { SettingsState } from 'src/app/store/settings/settings.state';

@Component({
   selector: 'samweb-common-settings',
   templateUrl: './common-settings.component.html',
   styleUrls: ['./common-settings.component.scss'],
})
export class CommonSettingsComponent implements OnInit {
   constructor(private store: Store) {}

   @Select(EnabledFeaturesState.isFeatureEnabled(FeatureEnum.CCO_PERM_EDIT_CONFIG_VIEW))
   public isFeatureEnabled$: Observable<boolean>;

   @Select(SettingsState.getCurrentLanguage)
   public currentLanguage$: Observable<LanguageType>;

   @Select(SettingsState.appliedTheme)
   public currentTheme$: Observable<ThemeType>;

   @Select(SettingsState.getWarnBeforeClosingTab)
   public warnBeforeClosingTab$: Observable<boolean>;

   public cancelIcon: IconDefinition = WellKnownIconsEnum.CANCEL.icon;

   public availableLanguageTypes: ReadonlyArray<LanguageType> = LanguageType.values().filter((x) => x.availableInWebAgent);
   public availableThemeTypes: ReadonlyArray<ThemeType> = ThemeType.values();

   ngOnInit() {}

   changeLanguage(languageType: LanguageType) {
      this.store.dispatch(new SettingsChangeApplicationLanguage(languageType));
   }

   changeTheme(themeType: ThemeType) {
      this.store.dispatch(new SetTemporaryTheme(null));
      this.store.dispatch(new SettingsChangeTheme(themeType));
   }

   warnBeforeClosingTabChanged(value: boolean) {
      this.store.dispatch(new SettingsChangeWarnBeforeClosingTab(value));
   }
}
